/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SysqueToggleButtonComponent } from './sysque-switch-button.component';

@NgModule({
  declarations: [SysqueToggleButtonComponent],
  imports: [CommonModule, FormsModule],
  exports: [SysqueToggleButtonComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SysqueToggleButtonModule {}
